import type { ArticleCategoryResponse } from '@shared/api-utils';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { JsonLd } from '../../JsonLd/JsonLd';

type ArticleBreadcrumbListProps = {
  category: ArticleCategoryResponse | undefined;
  slug: string;
  title: string;
  baseUrl: string;
};

function ArticleBreadcrumbList({ category, slug, title, baseUrl }: ArticleBreadcrumbListProps) {
  const t = useTranslations('magazine.breadcrumbs');
  return (
    <JsonLd
      json={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem' as const,
            name: t('site_name'),
            item: baseUrl,
          },
          {
            '@type': 'ListItem' as const,
            name: t('magazine_home_name'),
            item: `${baseUrl}${ROUTES.MAGAZINE.HOME}`,
          },
          ...(category
            ? [
                {
                  '@type': 'ListItem' as const,
                  name: category.title,
                  item: `${baseUrl}${category.seoInfo.canonicalUrl}`,
                },
              ]
            : []),
          {
            '@type': 'ListItem' as const,
            name: title,
            item: `${baseUrl}${ROUTES.MAGAZINE.ARTICLE.replace(':articleSlug', slug)}`,
          },
        ].map((item, index) => ({ ...item, position: index + 1 })),
      }}
    />
  );
}

export { ArticleBreadcrumbList, type ArticleBreadcrumbListProps };
